<template>
  <div class="nocode-page">
    <!-- En-tête avec dégradé -->
    <header class="header">
      <div class="header-content">
        <h1 class="main-title">Les services de notre agence No Code</h1>
        <p class="subtitle">Digitalisez votre PME de manière rapide et économique</p>
      </div>
    </header>

    <div class="content-container">
      <!-- Introduction - Partie 1 -->
      <section class="card intro-card">
        <div class="card-content">
          <h2 class="section-title">Modernisez-vous grâce à notre expertise en No Code</h2>
          <div class="text-and-illustration">
            <div class="text-content">
              <p>
                ✓ <strong><i>Créativité et innovation, pour réinventer votre marque sur le web</i></strong> : Pour garantir que votre projet soit toujours à la pointe des dernières évolutions numériques, nous explorons constamment de nouvelles idées et approches. Créer des solutions digitales uniques et sur mesure pour votre public est notre passion.
              </p><br>
              <p>
                ✓ <strong><i>Des résultats concrets, votre succès est notre récompense</i></strong> : Notre objectif ultime est de générer des résultats tangibles pour booster votre identité en ligne. Que ce soit en termes de visibilité grâce à notre expertise en SEO ou de la concrétisation de vos idées grâce à nos solutions no code / low code, votre succès est notre plus grande récompense.
              </p><br>
              <p>
                ✓ <strong><i>Notre expertise à votre service</i></strong> : Après plus d'une décennie à évoluer dans le numérique, notre équipe développe votre projet avec un arsenal technique constamment renouvelé.
              </p>
            </div>
            <div class="hero-illustration">
              <div class="dashboard-preview">
                <iframe
                  style="width: 100%; height: 100%; border: none; border-radius: 15px;"
                  src="https://www.youtube.com/embed/ctSvq3kxSWY"
                  title="Présentation de nos solutions No Code"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Introduction - Partie 2 -->
      <section class="card intro-card-2">
        <div class="card-content">
          <h2 class="section-title">Faites évoluer votre entreprise avec la méthode ÉCOD : Écoute, Collaboration, Objectifs, Données</h2>
          <div class="text-content">
            <p>
              ✓ <strong><i>Une stratégie sur mesure centrée sur l'écoute</i></strong> : Chez Web Passion, chaque projet commence par comprendre et définir vos objectifs. Nous croyons en une approche personnalisée où nous nous immergeons dans votre marque, votre public cible et votre secteur d'activité. Celle-ci nous permet de concevoir des stratégies personnalisées avec, en ligne de mire, des résultats tangibles.
            </p><br>
            <p>
              ✓ <strong><i>Un pilotage en étroite collaboration</i></strong> : Vous êtes au cœur de notre travail. En effet, vous êtes considérés comme des partenaires. Votre vision, vos idées et vos préoccupations sont au centre de chaque décision prise. C'est pour cela que nous collaborons étroitement avec vous à chaque étape du processus pour nous assurer que le projet évolue en harmonie avec vos attentes.
            </p><br>
            <p>
              ✓ <strong><i>Les données, le secret du succès</i></strong> : Nos décisions ne sont pas basées sur des suppositions mais sur des faits. Ainsi, des données concrètes sont utilisées pour orienter les stratégies et obtenir des résultats concrets. Nous collectons et réalisons une analyse approfondie de la data obtenue, que ce soit votre business, celui de vos concurrents ou votre domaine d'activité.
            </p>
          </div>
        </div>

        <div align="center">
          <a href="https://www.web-passion.fr/prestations-no-code/" target="_blank"
            style="display: block; width: fit-content; margin: 0 auto; background-color: #7c3aed1a; color: inherit; padding: 10px; border-radius: 9999px;">
            <strong>En savoir plus sur nos prestations No Code</strong>
          </a><br>
        </div>


      </section>

      <!-- Services Principaux -->
      <section class="card services-card">
        <div class="card-content">
          <h2 class="section-title">Quelles solutions No Code pouvons-nous créer pour accélérer votre transformation numérique ?</h2>
          
          <!-- Avantages (Cartes) -->
          <div class="advantages-grid">
            <!-- Service 1 -->
            <div class="advantage-card">
              <div class="advantage-number">1</div>
              <h3 class="advantage-title">Développement sur mesure</h3>
              <p class="advantage-description">
                Nous créons vos applications métier personnalisées, 
                vos sites web (vitrine, e-commerce), installons votre CRM et des ERP adaptés, développons vos marketplaces, 
                vos applications mobiles et vos tableaux de bord pour visualiser vos données.
              </p>
            </div>
  
            <!-- Service 2 -->
            <div class="advantage-card">
              <div class="advantage-number">2</div>
              <h3 class="advantage-title">Optimisation de processus & automatisation</h3>
              <p class="advantage-description">
                Nous automatisons vos tâches répétitives et chronophages, centralisons vos informations,
                réduisons les ressources nécessaires, simplifions vos workflows et
                facilitons le travail de vos équipes pour une meilleure efficacité.
              </p>
            </div>
  
            <!-- Service 3 -->
            <div class="advantage-card">
              <div class="advantage-number">3</div>
              <h3 class="advantage-title">Conseil & accompagnement</h3>
              <p class="advantage-description">
                Notre offre comprend l'audit et le diagnostic de vos besoins, la formation
                et la prise en main des outils, la mise à disposition d'experts en temps partagé,
                la maintenance, le support et le suivi régulier des performances de toutes vos solutions No-Code.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Avantages et Bénéfices -->
      <section class="card benefits-card">
        <div class="card-content">
          <h2 class="section-title">Comment le No Code peut-il vous aider à réaliser vos projets digitaux ?</h2>
          
          <div class="advantages-grid">
            <!-- Avantage 1 -->
            <div class="advantage-card">
              <div class="advantage-number">1</div>
              <h3 class="advantage-title">Rapidité de développement</h3>
              <p class="advantage-description">
                Créez des prototypes et solutions fonctionnelles rapidement. Finalisez vos projets
                en quelques semaines au lieu de mois.
              </p>
            </div>
  
            <!-- Avantage 2 -->
            <div class="advantage-card">
              <div class="advantage-number">2</div>
              <h3 class="advantage-title">Réduction drastique des coûts</h3>
              <p class="advantage-description">
                Économisez jusqu'à 75% par rapport au développement traditionnel,
                sans recruter de développeurs, pour un ROI rapide et tangible.
              </p>
            </div>
  
            <!-- Avantage 3 -->
            <div class="advantage-card">
              <div class="advantage-number">3</div>
              <h3 class="advantage-title">Flexibilité et agilité</h3>
              <p class="advantage-description">
                Effectuez des modifications et évolutions facilement et rapidement. Développez
                progressivement des solutions avec une approche itérative et agile.
              </p>
            </div>
  
            <!-- Avantage 4 -->
            <div class="advantage-card">
              <div class="advantage-number">4</div>
              <h3 class="advantage-title">Autonomie totale des équipes</h3>
              <p class="advantage-description">
                Bénéficiez de solutions faciles à prendre en main, avec des interfaces intuitives.
                 Vos équipes seront 100% autonomes après formation.
              </p>
            </div>
  
            <!-- Avantage 5 -->
            <div class="advantage-card">
              <div class="advantage-number">5</div>
              <h3 class="advantage-title">Gain de temps considérable</h3>
              <p class="advantage-description">
                Gagnez jusqu'à une semaine de travail par mois et par salarié. Réduisez les 10h
                perdues par semaine en recherche d'informations et automatisez les tâches manuelles répétitives.
              </p>
            </div>
  
            <!-- Avantage 6 -->
            <div class="advantage-card">
              <div class="advantage-number">6</div>
              <h3 class="advantage-title">Solutions personnalisées à 100%</h3>
              <p class="advantage-description">
                Créez des solutions adaptées précisément à vos besoins métiers avec des fonctionnalités
                complexes (bases de données, workflows) et une intégration avec vos outils existants.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Expertise Technique -->
      <section class="card expertise-card">
        <div class="card-content">
          <h2 class="section-title">Nos compétences techniques et notre boîte à outils pour transformer votre vision en réalité</h2>
          <div class="text-content">
            <p>
              Dans notre agence, les consultants No Code maîtrisent une large gamme d'outils spécialisés qui nous permettent
              de créer des solutions adaptées à tous vos besoins. Notre expertise technique
              couvre l'ensemble des domaines d'application du No Code.
            </p>
          </div>
          
          <div class="tools-container">
            <h3 class="subsection-title">Outils maîtrisés</h3>
            <div class="tools-grid">
              <span class="tool-tag">Ksaar</span>
              <span class="tool-tag">Make</span>
              <span class="tool-tag">Softr</span>
              <span class="tool-tag">Notion</span>
              <span class="tool-tag">Glide</span>
              <span class="tool-tag">Bubble</span>
              <span class="tool-tag">Airtable</span>
              <span class="tool-tag">Webflow</span>
              <span class="tool-tag">Zapier</span>
              <span class="tool-tag">Power Apps</span>
              <span class="tool-tag">HubSpot</span>
              <span class="tool-tag">Slack</span>
              <span class="tool-tag">Brevo</span>
              <span class="tool-tag">GPT</span>
              <span class="tool-tag">Salesforce</span>
            </div>
            
            <h3 class="subsection-title">Domaines d'application</h3>
            <div class="domains-grid">
              <span class="domain-tag">CRM</span>
              <span class="domain-tag">ERP</span>
              <span class="domain-tag">Automatisation</span>
              <span class="domain-tag">Sites Web</span>
              <span class="domain-tag">Applications Métier</span>
              <span class="domain-tag">Data Management</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Méthodologie -->
      <section class="card methodology-card">
      <div class="card-content">
          <h2 class="section-title">Une méthodologie qui s'ajuste à vos besoins et à vos objectifs</h2>
          <div class="methodology-flow">
          <!-- Étape 1 - Qualification -->
          <div class="method-step">
              <div class="step-circle">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10 17l-5-5 5-5M18 17l-5-5 5-5" stroke-linecap="round" stroke-linejoin="round" transform="rotate(220 12 12)"></path>
                  </svg>
              </div>
              </div>
              <h3>Qualification</h3>
              <p>Diagnostic initial</p>
          </div>
          
          <!-- Étape 2 - Analyse -->
          <div class="method-step">
              <div class="step-circle purple">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 3v18h18" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M7 14l3-3 4 4 5-5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Analyse</h3>
              <p>Conception solution</p>
          </div>
          
          <!-- Étape 3 - Développement -->
          <div class="method-step">
              <div class="step-circle">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M8 9l3 3-3 3M16 9l-3 3 3 3" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Développement</h3>
              <p>Configuration outils</p>
          </div>
          
          <!-- Étape 4 - Lancement -->
          <div class="method-step">
              <div class="step-circle purple">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Lancement</h3>
              <p>Tests et production</p>
          </div>
          
          <!-- Étape 5 - Formation -->
          <div class="method-step">
              <div class="step-circle">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2v6M12 18v4M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M2 12h6M16 12h6M4.93 19.07l4.24-4.24M14.83 9.17l4.24-4.24" stroke-linecap="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Formation</h3>
              <p>Accompagnement</p>
          </div>
          
          <!-- Étape 6 - Maintenance -->
          <div class="method-step">
              <div class="step-circle purple">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round"></circle>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Maintenance</h3>
              <p>Évolution continue</p>
          </div>
          </div>
      </div>
      </section>

      <!-- Témoignages clients -->
      <section class="testimonials-section">
        <h2 class="testimonials-title">Ce que disent nos clients</h2>
        
        <div class="testimonials-container">
          <!-- Témoignage 1 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Rémi D.</h3>
                <p class="client-company">Formateur</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>J'ai fait appel à Arynae pour créer une automatisation. 
              L'outil répond parfaitement à nos besoins, générant automatiquement les documents personnalisés 
              et les envoyant aux clients. Le processus est fiable et a considérablement 
              réduit notre charge administrative. Leur équipe a pris le temps de comprendre nos modèles de documents 
              et nos critères d'envoi, ce qui a permis une mise en place efficace.
              </p>
            </div>
            <div class="testimonial-border"></div>
          </div>
          
          <!-- Témoignage 2 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Martin R.</h3>
                <p class="client-company">Directeur du service clientèle</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>L'application No Code d'itinéraires touristiques développée par Arynae complète bien notre offre 
                de conseil voyage. Elle permet à nos clients de calculer des 
                itinéraires optimisés et de recevoir des recommandations personnalisées de lieux à visiter. 
                J'apprécie particulièrement la facilité avec laquelle nous pouvons mettre à jour la base de données des attractions. 
                Nos voyageurs sont ravis et nous avons 98% de retours positifs.
                </p>
            </div>
            <div class="testimonial-border"></div>
          </div>
          
          <!-- Témoignage 3 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Camille D.</h3>
                <p class="client-company">Directrice web-marketing</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>Le formulaire d'inscription à notre newsletter connecté à notre base de données No Code et 
                à notre CRM nous a permis de gagner 30% de nouveaux lecteurs. 
                La synchronisation avec notre système existant se fait sans accroc. 
                Je recommande vivement cette agence pour leur professionnalisme et leur capacité à livrer une 
                solution personnalisée qui répond précisément à nos besoins marketing.
              </p>
            </div>
            <div class="testimonial-border"></div>
          </div>
        </div>
        
        <div class="dots-navigation">
          <span class="dot active"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </section>

      <!-- Call to action -->
      <div class="cta-container">
        <span class="cta-button fake-link" @click="navigateTo('e1')">Prenez un rendez-vous en ligne / téléphonique / vidéo</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'NoCodeServicePage',
  setup() {
    useHead({
      title: 'Solutions No Code - Développement d\'applications sans code | Arynae',
      meta: [
        { name: 'description', content: 'Création d\'applications et de sites web sans coder. Nos solutions No Code vous permettent de développer rapidement des plateformes fonctionnelles et professionnelles à moindre coût.' },
        { name: 'keywords', content: 'no code, low code, développement sans code, applications no code, sites web sans programmation, bubble, webflow, airtable, zapier, Arynae' },
        { name: 'robots', content: 'index, follow' },
        { name: 'author', content: 'Arynae' },
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        // Open Graph essentiels
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Solutions No Code - Développement d\'applications sans code | Arynae' },
        { property: 'og:description', content: 'Création d\'applications et de sites web sans coder. Nos solutions No Code vous permettent de développer rapidement des plateformes fonctionnelles et professionnelles à moindre coût.' },
        { property: 'og:url', content: 'https://arynae.com/nocode' },
        { property: 'og:locale', content: 'fr_FR' },
        { property: 'og:image', content:'https://arynae.com/img/arynae-social-card.png' },
        { property: 'og:image:alt', content:'Agence digitale - Solutions No Code, SaaS, Chatbots & SEO' },
        // Twitter Card basiques
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Solutions No Code - Développement d\'applications sans code | Arynae' },
        { name: 'twitter:description', content: 'Création d\'applications et de sites web sans coder. Nos solutions No Code vous permettent de développer rapidement des plateformes fonctionnelles et professionnelles à moindre coût.' },
        { name: 'twitter:image', content: 'https://arynae.com/img/arynae-social-card.png' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }
      ],
      link: [
        { rel: 'canonical', href: 'https://arynae.com/nocode' },
        { rel: 'alternate', hreflang: 'fr', href: 'https://arynae.com/nocode' }
      ],
      htmlAttrs: {
        lang: 'fr'
      }
    })
    
    return {}
  },
  data() {
    return {}
  },
  methods: {
    navigateTo(code) {
      const routes = {
        'e1': 'https://cal.com/web-passion/rdv'
      };
      
      window.open(routes[code] || code, '_blank');
    }
  }
}
</script>

<style scoped>
.nocode-page {
  font-family: Arial, sans-serif;
  color: #333;
}

/* Header Styles */
.header {
  background: linear-gradient(to right, #2563EB, #7C3AED);
  padding-bottom: 6rem;
  color: white;
}

.header-content {
  text-align: center;
  padding: 5rem 2rem 3rem;
}

.main-title {
  font-size: 2.75rem;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.25rem;
  max-width: 800px;
  margin: 0 auto;
}

/* Content Container */
.content-container {
  max-width: 1200px;
  margin: -3rem auto 4rem;
  padding: 0 2rem;
}

/* Card Styles */
.card {
  background: linear-gradient(to bottom, #ffffff, #f3f4f6);
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 2rem;
  overflow: hidden;
}

.card-content {
  padding: 2rem;
}

.section-title {
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  color: #333;
  display: block;
}

.subsection-title {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #555;
  text-align: center;
}

.text-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

/* Intro Card with Illustration */
.text-and-illustration {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.text-and-illustration .text-content {
  flex: 1;
  min-width: 280px;
}

/* Hero illustration and dashboard preview */
.hero-illustration {
  flex: 1;
  min-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dashboard-preview {
  width: 100%;
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Advantages Grid */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.advantage-card {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  position: relative;
}

.advantage-number {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(to right, #4158D0, #C850C0);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.advantage-title {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #333;
}

.advantage-description {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #555;
}

/* Tools section */
.tools-container {
  margin-top: 2rem;
}

.tools-grid, .domains-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin: 1.5rem 0 2.5rem;
}

.tool-tag {
  background: linear-gradient(to right, #4158D0, #7C3AED);
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.9rem;
}

.domain-tag {
  background: linear-gradient(to right, #C850C0, #7C3AED);
  color: white;
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  font-size: 1rem;
}

/* Methodology section */
.methodology-steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 2rem;
  margin-top: 2rem;
}

.methodology-step {
  text-align: center;
  flex: 0 1 150px;
}

.step-number {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(to right, #4158D0, #C850C0);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0 auto 1rem;
}

.methodology-step h3 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.methodology-step p {
  font-size: 0.9rem;
  color: #555;
}

/* Testimonials Section */
.testimonials-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  padding: 1rem;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  overflow-x: auto;
  padding-bottom: 1rem; /* Espace pour la scrollbar */
}

.testimonial-card {
  flex: 0 0 calc(33.333% - 1.5rem);
  min-width: 280px;
  background: white;
  border-radius: 16px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04), 0 0 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Cache la scrollbar sur certains navigateurs mais garde la fonctionnalité */
.testimonials-container::-webkit-scrollbar {
  height: 6px;
}

.testimonials-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.testimonials-container::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .testimonials-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.dots-navigation {
  display: none;
}

.dots-navigation {
  display: none; /* Cache les points s'ils ne sont pas nécessaires */
}

@media (max-width: 992px) {
  .testimonials-container {
    flex-direction: column;
    padding: 1rem;
    gap: 2rem;
  }
  
  .testimonial-card {
    width: 100%;
    margin-bottom: 1rem;
  }
}

.dots-navigation {
display: none; /* Cache les points s'ils ne sont pas nécessaires */
}


.testimonials-container {
  display: flex;
  gap: 2rem;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  overflow-x: visible;
}

.testimonial-card:hover {
transform: translateY(-8px);
box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08), 0 0 12px rgba(0, 0, 0, 0.06);
}

.testimonial-header {
display: flex;
align-items: center;
padding: 1.5rem 1.5rem 0.5rem;
}

.client-info {
flex: 1;
}

.client-name {
font-size: 1.25rem;
font-weight: 700;
margin: 0 0 0.25rem;
color: #1a202c;
}

.client-company {
font-size: 0.9rem;
color: #718096;
margin: 0 0 0.5rem;
}

.rating {
display: flex;
font-size: 1.1rem;
color: #FFC107;
}

.testimonial-body {
padding: 0.5rem 1.5rem 2rem;
font-size: 1rem;
line-height: 1.7;
color: #4A5568;
flex: 1;
}

.testimonial-border {
height: 5px;
background: linear-gradient(90deg, #2563EB, #7C3AED, #EC4899);
width: 100%;
}

.dots-navigation {
display: flex;
justify-content: center;
gap: 0.5rem;
margin-top: 2.5rem;
}

.dot {
width: 10px;
height: 10px;
border-radius: 50%;
background-color: #CBD5E0;
cursor: pointer;
transition: all 0.3s ease;
}

.dot:hover {
background-color: #A0AEC0;
}

.dot.active {
background: linear-gradient(90deg, #2563EB, #7C3AED);
width: 30px;
border-radius: 10px;
}

/* Media queries pour responsive */
@media (max-width: 768px) {
.testimonials-container {
  padding: 1rem;
  flex-direction: column;
  gap: 2rem;
}

.testimonial-card {
  min-width: 100%;
}

.testimonials-title {
  font-size: 2rem;
  margin-bottom: 2.5rem;
}
}

.client-name {
  font-weight: bold;
  font-style: normal;
  margin-top: 1rem;
}

/* Call to Action */
.cta-container {
  text-align: center;
  margin: 3rem 0;
}

.cta-button {
  background: linear-gradient(to right, #4158D0, #C850C0);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: inline-block;
  max-width: 100%;
  word-wrap: break-word;
  text-align: center; /* Cette propriété assure que le texte est centré sur plusieurs lignes */
}

@media (max-width: 768px) {
  .cta-button {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
    width: 90%;
  }
  .text-and-illustration {
    flex-direction: column;
  }
 
  .text-and-illustration .text-content,
  .illustration-container {
    min-width: 0;
    width: 100%;
  }
}


/* Special styling for intro cards */
.intro-card, .intro-card-2 {
  margin-bottom: 1.5rem;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .header-content {
    padding: 4rem 1rem 2rem;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .content-container {
    padding: 0 1rem;
  }
  
  .advantages-grid {
    grid-template-columns: 1fr;
  }
  
  .text-and-illustration {
    flex-direction: column;
  }
  
  .text-and-illustration .text-content {
    order: 2;
  }
  
  .hero-illustration {
    order: 2;
  }
  
  .youtube-container {
    height: 200px; /* Hauteur réduite sur mobile */
  }
  
  .dashboard-preview {
    height: 200px; /* Hauteur réduite sur mobile */
  }
  
  .methodology-steps {
    flex-direction: column;
    align-items: center;
  }
  
  .methodology-step {
    flex: 0 1 auto;
    width: 100%;
    max-width: 200px;
  }


  
  .hero-illustration {
    min-width: 0;
    width: 100%;
    margin-bottom: 1.5rem;  /* Ajoute de l'espace sous la vidéo */
  }
  
  .dashboard-preview {
    width: 100%;
    height: 0;
    position: relative;
    padding-bottom: 56.25%;  /* Ratio 16:9 pour la vidéo */
  }
  
  .dashboard-preview iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}


/* Méthodologie flow style moderne */
.methodology-flow {
display: flex;
flex-wrap: wrap;
justify-content: center;
gap: 1rem;
margin: 3rem 0 1rem;
position: relative;
}

.methodology-flow:before {
content: '';
position: absolute;
top: 40px;
left: 10%;
width: 80%;
height: 3px;
background: linear-gradient(to right, #E2E8F0, #E2E8F0 50%, transparent 50%, transparent);
background-size: 20px 3px;
z-index: 0;
}

.method-step {
flex: 0 1 140px;
display: flex;
flex-direction: column;
align-items: center;
text-align: center;
z-index: 1;
}

.step-circle {
width: 80px;
height: 80px;
border-radius: 50%;
background: linear-gradient(to right, #4158D0, #4D5DFA);
display: flex;
justify-content: center;
align-items: center;
margin-bottom: 1rem;
box-shadow: 0 4px 10px rgba(65, 88, 208, 0.3);
}

.step-circle.purple {
background: linear-gradient(to right, #7C3AED, #C850C0);
box-shadow: 0 4px 10px rgba(124, 58, 237, 0.3);
}

.step-icon {
width: 40px;
height: 40px;
color: white;
display: flex;
justify-content: center;
align-items: center;
}

.method-step h3 {
font-size: 1.1rem;
margin-bottom: 0.25rem;
color: #333;
}

.method-step p {
font-size: 0.9rem;
color: #555;
margin: 0;
}

@media (max-width: 768px) {
.methodology-flow {
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.methodology-flow:before {
  width: 3px;
  height: 80%;
  top: 10%;
  left: 50%;
  background: linear-gradient(to bottom, #E2E8F0, #E2E8F0 50%, transparent 50%, transparent);
  background-size: 3px 20px;
}

.method-step {
  width: 100%;
  max-width: 200px;
}
}

</style>